import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
import { registerWebhook } from '../../model/registerWebhook';
import { getRepositoryFullnameFromMatch } from '../../utils/getRepository';
import { replaceAsciiCharWithSlash } from '../../utils/resolveBranch';
import { Picker } from './components/Picker';
export class RepositoryPicker extends Component {
    constructor() {
        super(...arguments);
        this.getRepositoryFromStore = (repositories, match) => {
            const repositoryFullname = replaceAsciiCharWithSlash(getRepositoryFullnameFromMatch(match));
            return (repositories.list[match.params.vcs] || {})[repositoryFullname];
        };
        this.handleRegisterWebhook = (vcs, owner, repository) => {
            const { dispatch, repositories, user } = this.props;
            return registerWebhook(user, this.getRepositoryFromStore(repositories, { params: { owner, repository, vcs } }), 
            // @ts-expect-error TS2345: Argument of type Function is not assignable to parameter of type
            dispatch, this.context);
        };
    }
    // ToDo: Do we still need this?
    UNSAFE_componentWillReceiveProps(nextProps) {
        return this.setState(() => ({ values: nextProps.values }));
    }
    render() {
        const { onChange, values, className, user, options } = this.props;
        return _jsx(Picker, { className: className, options: options, defaultValues: values, user: user.user, onRegisterWebhook: this.handleRegisterWebhook, onChange: onChange });
    }
}
RepositoryPicker.contextType = ApiV2ModelContext;
RepositoryPicker.defaultProps = {
    className: '',
};
const mapStateToProps = (state) => ({
    repositories: state.repositories,
    user: state.user,
});
export default connect(mapStateToProps)(RepositoryPicker);
